import(/* webpackMode: "eager", webpackExports: ["MuiLightThemeProvider"] */ "/home/ec2-user/website/salontymwebweb/app/components/providers/MuiLightThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/app/globals.css?id=reloadevertime");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ec2-user/website/salontymwebweb/node_modules/react-hot-toast/dist/index.mjs");
